import Header from 'components/Header/Header';
import LoadingButton from 'components/LoadingButton/LoadingButton';
import { useEffect, useState } from 'react';
import { Row, Col, Card, Alert, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { isEmailValid } from 'utils/validation.util';
import './ForgotPassword.css';

const ForgotPassword = () => {
    const { t } = useTranslation();
    const [alert, setAlert] = useState(null);
    const [email, setEmail] = useState('');
    const [validated, setValidated] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const resetPassword = async (event) => {
        event.preventDefault();
        if (validate()) {
            setIsLoading(true);
            fetch(`${process.env.REACT_APP_PROXY_URL || ''}/resetpassword`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email,
                }),
            })
                .then((data) => data.json())
                .then((data) => {
                    if (data.status === 500) {
                        setAlert({
                            type: 'danger',
                            message: 'password_reset_fail',
                        });
                    } else {
                        setAlert({
                            type: 'success',
                            message: 'if_email_entered_exists',
                        });
                    }
                })
                .catch((error) => {
                    console.log({ error });
                    setAlert({
                        type: 'danger',
                        message: 'password_reset_fail',
                    });
                })
                .finally(() => setIsLoading(false));
        }
    };

    const validate = () => {
        setAlert(null);
        setEmailError('');
        if (!email) {
            setEmailError('email_empty_error');
            setValidated(true);
            return false;
        } else if (!isEmailValid(email)) {
            setEmailError('valid_email_error');
            setValidated(true);
            return false;
        }

        setEmail(email.trim());
        return true;
    };

    useEffect(() => {
        if (validated) setValidated(false);
    }, [email]);

    return (
        <>
            <Header />
            <div className="forgot-pass container">
                {alert && (
                    <Row className="mt-4 d-flex justify-content-center">
                        <Col md={6}>
                            <Alert variant={alert.type} className="mb-0">
                                {t(alert.message)}
                            </Alert>
                        </Col>
                    </Row>
                )}
                <Row className="mt-4 d-flex justify-content-center">
                    <Col md={6}>
                        <Card>
                            <Card.Header>{t('forgot_password')}</Card.Header>
                            <Card.Body>
                                <Form onSubmit={resetPassword}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('email')}</Form.Label>
                                        <Form.Control
                                            isInvalid={validated && emailError}
                                            type="text"
                                            value={email}
                                            onChange={(event) => setEmail(event.target.value)}
                                        />
                                        {emailError && (
                                            <Form.Control.Feedback type="invalid">
                                                {t(emailError)}
                                            </Form.Control.Feedback>
                                        )}
                                    </Form.Group>
                                    <div className="d-flex justify-content-end">
                                        <LoadingButton
                                            type="submit"
                                            isLoading={isLoading}
                                            maxWidth="auto"
                                        >
                                            {t('reset_password')}
                                        </LoadingButton>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default ForgotPassword;
